import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: React.ReactNode;
  containerId?: string;
}

const Portal: React.FC<PortalProps> = ({ children, containerId = 'portal-root' }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    // Check if the portal container exists
    let element = document.getElementById(containerId);

    // If it doesn't exist, create it
    if (!element) {
      element = document.createElement('div');
      element.setAttribute('id', containerId);
      document.body.appendChild(element);
    }

    // Cleanup function
    return () => {
      const element = document.getElementById(containerId);
      if (element && element.childNodes.length === 0) {
        document.body.removeChild(element);
      }
    };
  }, [containerId]);

  // Only render the portal content after component is mounted
  if (!mounted) return null;

  // Get the container element
  const portalContainer = document.getElementById(containerId);

  // Only create portal if container exists
  if (!portalContainer) return null;

  // Render children into the portal container
  return createPortal(children, portalContainer);
};

export default Portal;
